import { IKitten } from "../model/Kitten";
import ImageLoader from "./ImageLoader";

class Kitten extends ImageLoader implements IKitten {
  public name: IKitten["name"] = "";
  public dob: IKitten["dob"];
  public reserved: IKitten["reserved"] = false;
  public litter: IKitten["litter"];
  public images: IKitten["images"] = [];
  public personality: IKitten["personality"] = [];
  public description: IKitten["description"] = "";

  constructor(name: IKitten["name"], reserved: IKitten["reserved"], dob?: IKitten["dob"], description?: IKitten["description"]) {
    super();
    this.name = name;
    this.reserved = reserved;
    this.dob = dob;
    this.description = description;
    this.images = super.loadImages("kittens", name);
  }

  public addPersonality(personality: IKitten["personality"]): this {
    this.personality = personality;
    return this;
  }

  public addLitter(litter: IKitten["litter"]): this {
    this.litter = litter;
    return this;
  }
}

export default Kitten;